import { __awaiter } from "tslib";
import useHttp from './use-http';
const useAffiliateLinks = () => {
    const createDeepLink = ({ contactId, linkId, parentLinkId, url }) => __awaiter(void 0, void 0, void 0, function* () {
        const { http } = useHttp();
        const postUrl = `/contact/${contactId}/affiliate-links`;
        return yield http.post(postUrl, {
            link_id: linkId,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            parent_link_id: parentLinkId,
            destination_url: url
        });
    });
    const fetchLinksContext = ({ urls, contactId }) => __awaiter(void 0, void 0, void 0, function* () {
        const { http } = useHttp();
        const postUrl = `/contact/${contactId}/links-context`;
        return yield http.post(postUrl, {
            urls
        });
    });
    return {
        createDeepLink,
        fetchLinksContext
    };
};
export default useAffiliateLinks;
